
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 84 84","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42 84C18.803 84 0 65.197 0 42S18.803 0 42 0s42 18.803 42 42-18.803 42-42 42zm-5.788-57.057a1.68 1.68 0 00-2.612 1.394v27.326a1.68 1.68 0 002.612 1.394l20.492-13.658a1.684 1.684 0 000-2.798L36.212 26.943z","fill":"#232324"}})])
          )
        }
      }
    